import { UnicodeEntity } from '@mews/enums';
import { Reservation } from '@mews-commander/data-access';
import { ResourceCategoryName, ResourceCategoryNameByResource } from '../../../../components/commander-ui';
import { ResourceName } from '../../../../components/reservation/ResourceName';

type Props = Pick<Reservation, 'assignedResourceId' | 'requestedCategoryId' | 'serviceId'>;

const ReservationSecondaryText = ({ assignedResourceId, requestedCategoryId, serviceId }: Props) => (
    <>
        {assignedResourceId ? (
            <ResourceCategoryNameByResource resourceId={assignedResourceId} serviceId={serviceId} short />
        ) : (
            <ResourceCategoryName id={requestedCategoryId} serviceId={serviceId} short />
        )}
        {UnicodeEntity.NoBreakSpace}
        {assignedResourceId ? <ResourceName resourceId={assignedResourceId} /> : null}
    </>
);

export default ReservationSecondaryText;
